module.exports = __webpack_public_path__ + "img/long-arrow-right-icon.svg";